import { custom } from "./utilities";
import { globalSystemConstants } from "../../constants";

const activateSpinner = (data) => {
  return (dispatch) => {
    dispatch(custom(data, globalSystemConstants.SPINNER_ACTIVATE));
  };
};

const deactivateSpinner = (data) => {
  return (dispatch) => {
    dispatch(custom(data, globalSystemConstants.SPINNER_DIACTIVATE));
  };
};

const setTotalCount = (data) => {
  return (dispatch) => {
    dispatch(custom(data, globalSystemConstants.TOTAL_COUNT));
  };
};

export const systemActions = {
  activateSpinner,
  deactivateSpinner,
  setTotalCount,
};
